import React from "react";
import { useNavigate } from 'react-router-dom';
import "./style/MainBanner.css"
import BannerChest from "../assets/image/banner-chest.svg";

import { Trans } from "react-i18next";

export default function MainBanner({}) {
  const navigate = useNavigate();

  return (
    <div className="main-banner-wrapper">
      <div className="main-banner" style={{ backgroundImage: `url(${BannerChest})` }}>
          <span className="main-banner-text"><Trans i18nKey="main-banner-text" components={{ br: <br /> }} /></span>
          <button className="banner-button">
            <Trans i18nKey="buy" />
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.94194 2.89137C7.69786 2.64729 7.30214 2.64729 7.05806 2.89137C6.81398 3.13545 6.81398 3.53118 7.05806 3.77525L11.3677 8.08491C12.4254 9.14258 12.4254 10.8574 11.3677 11.9151L7.05806 16.2247C6.81398 16.4688 6.81398 16.8645 7.05806 17.1086C7.30214 17.3527 7.69786 17.3527 7.94194 17.1086L12.2516 12.799C13.7974 11.2531 13.7974 8.74685 12.2516 7.20102L7.94194 2.89137Z" fill="#FDFDFD"/>
            </svg>
          </button>
      </div>
    </div>
  );
}

